import Lottie from 'lottie-react';

import aiAssistantLoaderAnimation from '../../../assets/animations/aiAssistantLoader.json';

// Starts and ends on the bare logo, so paused it doubles as the static icon
const AiAssistantLoaderIcon = ({className, isAnimating = true}) => (
    <Lottie animationData={aiAssistantLoaderAnimation} className={className} autoplay={isAnimating} loop />
);

export default AiAssistantLoaderIcon;
